<template>
    <component
        :is="componentStyle.comp"
        v-bind="{ ...componentStyle.props }"
        v-on="componentStyle.on"
        v-model="show"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on"
                ><v-badge
                    :content="unreadNotifications"
                    :color="unreadNotifications ? 'soli-red' : null"
                    overlap
                    :bordered="!!unreadNotifications"
                >
                    <v-icon
                        class="text-shadow-blue"
                        :color="
                            $page.component == 'Explore' ? 'white' : 'accent'
                        "
                        >notifications</v-icon
                    ></v-badge
                ></v-btn
            >
        </template>
        <v-sheet>
            <v-container>
                <v-row>
                    <div>
                        <v-card-title class="soli-grey"
                            >Notifications</v-card-title
                        >
                        <v-card-subtitle
                            v-if="!untouchedNotifications"
                            class="soli-grey"
                            >You're all caught up!</v-card-subtitle
                        >
                    </div>

                    <v-spacer />
                    <v-btn
                        icon
                        color="dark"
                        small
                        class="ma-4"
                        :href="`/profile/${$page.props.auth.user.id}/preferences`"
                    >
                        <v-icon small>settings</v-icon>
                    </v-btn>
                </v-row>

                <v-list
                    class="overflow-y-auto"
                    max-height="600"
                    v-scroll.self="onScroll"
                >
                    <v-list-item
                        v-for="(item, idx) in notifications.data"
                        :key="idx"
                        :class="{
                            unread: !item.interacted_at,
                            'cursor-pointer': !item.interacted_at,
                        }"
                        @click="handleClick(item)"
                    >
                        <v-list-item-avatar>
                            <v-img :src="item.data.image"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title
                                class="ws-wrap"
                                :class="{
                                    'soli-grey': item.interacted_at,
                                }"
                                >{{ item.data.title }}</v-list-item-title
                            >
                            <v-list-item-subtitle class="ws-wrap">{{
                                item.data.subtitle
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle
                                v-if="item.data.download"
                                class="caption"
                                ><v-icon small left color="dark"
                                    >attachment</v-icon
                                >{{ item.data.file_name }}</v-list-item-subtitle
                            >
                            <small class="accent--text">{{
                                moment(item.created_at).fromNow()
                            }}</small></v-list-item-content
                        >
                    </v-list-item>
                    <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto my-3"
                        type="list-item-avatar-three-line@3"
                    ></v-skeleton-loader>
                </v-list> </v-container
        ></v-sheet>
    </component>
</template>

<script>
import axios from "axios";
import { VMenu, VBottomSheet } from "vuetify/lib";

export default {
    components: {
        VMenu,
        VBottomSheet,
    },
    data: function () {
        return {
            show: false,
            notifications: this.$page.props.auth.notifications,
            unreadNotifications: this.$page.props.auth.unreadNotifications,
            loading: false,
        };
    },
    mounted() {
        //this.fetchNotifications();

        const channel = this.$root.channels.auth;
        if (!channel) return;
        channel.notification((event) => {
            if (event.message) return;
            this.fetchNotifications();
        });
    },
    computed: {
        untouchedNotifications() {
            if (!this.notifications.data) return false;
            return !!this.notifications.data.filter((e) => !e.interacted_at)
                .length;
        },
        componentStyle() {
            let mobileDevice =
                this.$vuetify.breakpoint.xs || this.bottomSheetOnly;
            return {
                comp: mobileDevice ? "v-bottom-sheet" : "v-menu",
                props: mobileDevice
                    ? {
                          class: "soli-round mx-1",
                          "content-class":
                              "half-round overflow-hidden safe-bottom white",
                          height: "90vh",
                      }
                    : {
                          left: true,
                          "offset-y": true,
                          "min-width": 400,
                          "max-width": mobileDevice ? null : 400,
                          "close-on-content-click": false,
                          "content-class": "soli-round",
                      },
            };
        },
    },
    methods: {
        async downloadFile(path) {
            try {
                const response = await axios.get(
                    `/download-report/${encodeURIComponent(path)}`
                );
                if (response.status === 200 && response.data.url) {
                    const url = response.data.url;
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = url.split("/").pop();
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    console.error(
                        "Failed to get download URL:",
                        response.statusText
                    );
                }
            } catch (error) {
                console.error("Error downloading file:", error);
            }
        },
        onScroll(scroll) {
            if (this.loading) return;
            let position = scroll.target.scrollTop;
            let scrollHeight = scroll.target.scrollHeight;
            let totalHeight = scroll.target.offsetHeight;
            let target = scrollHeight - totalHeight;
            if (position < target) return;
            this.loadMore();
        },
        markAsRead() {
            axios
                .put(
                    `/api/notifications/${this.$page.props.auth.user.id}/mark-as-read`
                )
                .then((resp) => {
                    this.unreadNotifications = 0;
                });
        },
        handleClick(notification) {
            if (!notification.interacted_at && notification.id) {
                axios
                    .put(
                        `/api/notifications/${this.$page.props.auth.user.id}/${notification.id}/interact`
                    )
                    .then((resp) => {
                        if (JSON.parse(resp.data.data).link) return;
                        this.fetchNotifications();
                    });
            }
            if (notification.data.download) {
                this.downloadFile(notification.data.download);
                /* this.$inertia.get(
                    `/download-report/${notification.data.download}`
                );*/
            }
            if (notification.data.link) {
                this.$inertia.visit(notification.data.link);
            }
        },
        fetchNotifications() {
            if (this.show) this.markAsRead();
            axios
                .get(
                    `/api/notifications/${this.$page.props.auth.user.id}/index`
                )
                .then((resp) => {
                    this.notifications = resp.data.notifications;
                    this.unreadNotifications = resp.data.unreadNotifications;
                });
        },
        loadMore() {
            if (!this.notifications.next_page_url) return;
            this.loading = true;
            axios.get(this.notifications.next_page_url).then((resp) => {
                this.notifications = {
                    ...resp.data.notifications,
                    data: [
                        ...this.notifications.data,
                        ...resp.data.notifications.data,
                    ],
                };
                this.loading = false;
            });
        },
    },
    watch: {
        show(val) {
            if (val) {
                if (this.unreadNotifications) this.markAsRead();
            }
        },
    },
};
</script>

<style>
.ws-wrap {
    white-space: normal;
}

.unread {
    /*background: rgba(120, 178, 233, 0.2);*/
    border-left: 4px solid #228cbd;
}
</style>
